import ReactDOM from "react-dom";

export const getImageUrl = (imageName, baseUrl) =>{
  if (!imageName) return "";

  try {
    new URL(imageName);
    return imageName;
  } catch {
    return `${baseUrl}/storage/assets/uploads/${imageName}`;
  }
};